import { MKMarkup } from '@bluebeam/markupkit-web';
import { Markup as MarkupRecord } from 'records/Markup';

class Markup {
  markup: MarkupRecord;

  mkMarkup: MKMarkup | null = null;

  selected = false;

  hidden = false;

  editable = true; // should this be default false?

  isPunch = false;

  isNewPunch = false; // is it a punch that is in the process of being created

  isRFI = false;

  isNewRFI = false;

  isOpen = false;

  constructor(markup = new MarkupRecord()) {
    this.markup = markup;
  }
}

export default Markup;
